if (!customElements.get('variant-selects')) {
    customElements.define(
        'variant-selects',
        class VariantSelects extends HTMLElement {
            constructor() {
                super();
            }

            get selectedOptionValues() {
                return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
                    ({dataset}) => dataset.optionValueId
                );
            }

            getInputForEventTarget(target) {
                return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
            }

            connectedCallback() {
                this.triggerColorSelection();
                this.addEventListener('change', (event) => {
                    const target = this.getInputForEventTarget(event.target);
                    this.updateSelectedSwatchValue(event);
                    if(document.getElementById("pdp-product-bundle")){
                        let itemNameMerge = ""
                        const activeItems = document.querySelectorAll("variant-selects input:checked");

                        activeItems.forEach((item,index,array) => {
                            if (index === array.length - 1) {
                                itemNameMerge += item.value
                            }else{
                                itemNameMerge += item.value + " "
                            }
                        })
                        this.updateMediaGalleryByColor(itemNameMerge);
                    }else{
                        this.updateMediaGalleryByColor(target.value);
                    }


                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
                        data: {
                            target,
                            event,
                            selectedOptionValues: this.selectedOptionValues,
                        },
                    });
                });
            }

            triggerColorSelection() {
                const stickySelect = document.querySelector(".sticky-atc-bar__variant-select");
                if (stickySelect) {
                    stickySelect.addEventListener("change", (e) => {
                        const selectedVariantId = e.target.value;

                        const targetRadio = document.querySelector(
                            `variant-selects input[data-variant-value-id="${selectedVariantId}"]`
                        );
                        const targetLabel = document.querySelector(
                            `variant-selects label[data-variant-value-id="${selectedVariantId}"]`
                        );

                        if (targetRadio) {
                            setTimeout(() => {
                                targetLabel.click();
                                // Check the corresponding radio input
                                targetRadio.checked = true;
                                // this.updateMediaGalleryByColor("White");
                                this.updateMediaGalleryByColor(selectedVariantId);
                                // Dispatch native change event to trigger variant-selects behavior
                                const changeEvent = new Event("change", { bubbles: true });
                                targetRadio.dispatchEvent(changeEvent);
                            },100)
                        }
                    });
                }
            }

            updateSelectedSwatchValue({target}) {
                const {value, tagName} = target;
                if (tagName === 'SELECT' && target.selectedOptions.length) {
                    Array.from(target.options)
                        .find((option) => option.getAttribute('selected'))
                        ?.removeAttribute('selected');
                    target.selectedOptions[0].setAttribute('selected', 'selected');

                    const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
                    const selectedDropdownSwatchValue = target
                        .closest('.product-form__input')
                        ?.querySelector('[data-selected-value] > .swatch');
                    if (!selectedDropdownSwatchValue) return;
                    if (swatchValue) {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
                    } else {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
                    }

                    selectedDropdownSwatchValue.style.setProperty(
                        '--swatch-focal-point',
                        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
                    );
                } else if (tagName === 'INPUT' && target.type === 'radio') {
                    const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
                    if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
                }
            }

            updateMediaGalleryByColor(selectedColor) {
                const galleryRoot = document.querySelector('media-gallery');
                if (!galleryRoot) return;

                const allThumbs = galleryRoot.querySelectorAll('.product__thumbs-item');
                allThumbs.forEach((thumb) => {
                    const thumbName = thumb.getAttribute('data-name');

                    // Always show eko gallery thumbnail, show matching variant thumbnails
                    const shouldShow = thumbName === selectedColor || thumbName === 'eko-gallery';
                    thumb.style.display = shouldShow ? 'block' : 'none';
                    thumb.classList.remove('swiper-slide-thumb-active');
                });

                const visibleThumb = Array.from(allThumbs).find(
                    (el) => getComputedStyle(el).display !== 'none'
                );
                if (visibleThumb) {
                    visibleThumb.classList.add('swiper-slide-thumb-active');
                    const mediaId = visibleThumb.getAttribute('data-target') || visibleThumb.getAttribute('data-media-id');
                    const targetSlide = galleryRoot.querySelector(
                        `.swiper-slide[data-target="${mediaId}"], .swiper-slide[data-media-id="${mediaId}"]`
                    );
                    const thumbsSwiper = galleryRoot.sliderInstance?.slider?.thumbs?.swiper;
                    thumbsSwiper.update();
                    thumbsSwiper.updateSlidesClasses();
                    if (thumbsSwiper) thumbsSwiper.slideTo(0);
                }
            }
        }
    );
}
